export const EmailExpeditorThingTypeMrn = "mrn:sl2:::emailExpeditor";
